import {
  CANCEL_EDITION,
  CLEAN_ERROR,
  CREATE_GAME_DEPLOYMENT_TEMPLATE,
  CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR,
  CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING,
  DELETE_GAME_DEPLOYMENT_TEMPLATE,
  DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR,
  DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING,
  FETCH_GAME_DEPLOYMENT_TEMPLATE,
  FETCH_GAME_DEPLOYMENT_TEMPLATE_ID,
  FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_ERROR,
  FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_PENDING,
  FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR,
  FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING,
  GameTemplateActions,
  GameTemplateReducerState,
  SORT,
  UPDATE_GAME_DEPLOYMENT_TEMPLATE,
  UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR,
  UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING,
} from 'services/GameHosting/DeploymentTemp/GameTemplate/types';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  gameDepTemp: [],
  gameDepTempId: undefined,
  sortBy: 'name',
  sortDirection: 'ASC',
  params: undefined,
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,
  updateIsCompleted: false,
  updateIsPending: false,
  updateIsError: null,
  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,
} satisfies GameTemplateReducerState;

const gameTemplateReducer = (previousState: GameTemplateReducerState | undefined, action: GameTemplateActions): GameTemplateReducerState => {
  const state: GameTemplateReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_GAME_DEPLOYMENT_TEMPLATE:
      return {
        ...state,
        gameDepTemp: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params?.sortSearchValue ?? state.params?.value,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };

    case FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR: {
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,
      };
    }

    case FETCH_GAME_DEPLOYMENT_TEMPLATE_ID:
      return {
        ...state,
        gameDepTempId: action.data,
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,
      };

    case CREATE_GAME_DEPLOYMENT_TEMPLATE: {
      if (!action.data) {
        return { ...state, createIsCompleted: true, createIsPending: false, createIsError: new Error('Nothing to create') };
      }

      return {
        ...state,
        gameDepTemp: addNew(action.data, state.gameDepTemp),
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    }

    case CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,
        createIsError: action.error,
      };

    case UPDATE_GAME_DEPLOYMENT_TEMPLATE: {
      return {
        ...state,
        gameDepTemp: state.gameDepTemp.map((item) => {
          if (`${item.id}` === action.data?.id) {
            return {
              ...item,

              ...action.data,
            };
          }

          return item;
        }),
        updateIsCompleted: true,
        updateIsPending: false,
        updateIsError: null,
      };
    }

    case UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        updateIsCompleted: false,
        updateIsPending: true,
        updateIsError: null,
      };
    case UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        updateIsCompleted: true,
        updateIsPending: false,
      };

    case DELETE_GAME_DEPLOYMENT_TEMPLATE: {
      return {
        ...state,
        gameDepTemp: state.gameDepTemp.filter(({ id }) => !action.data || `${id}` !== `${action.data.id}`),
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: action.error,
      };
    case CANCEL_EDITION:
      return {
        ...state,
        gameDepTemp: state.gameDepTemp.filter((item) => item.id),
      };

    case SORT: {
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        params: action.params,
        gameDepTemp: sort(state.gameDepTemp, {
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    }

    case CLEAN_ERROR: {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,
          [action.reducerProperty]:
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };
    }

    case 'RESET_GAME_TEMPLATE_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default gameTemplateReducer;
